import { put, takeEvery, takeLatest } from 'redux-saga/effects';
import couponTypes from './types';

import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import couponActions from './actions';
import services from './services';
import routes from 'Pages/router/constants/routes';

function* getCouponRequest(action) {
	try {
		let response = yield sagaCallService(
			services.getCouponList,
			action,
			action.payload
		);
		yield put(couponActions.getCouponsSuccess(response));
	} catch (e) {
		// yield sagaErrorDispatcher(e, action, couponActions.getCouponsFailure);
	}
}

function* invalidateCouponRequest(action) {
	try {
		let response = yield sagaCallService(
			() => services.invalidateCoupon(action.payload),
			action
		);

		if (action?.payload?.manageRedirection) {
			// yield put(
			// 	couponActions.invalidateCouponsRequest({
			// 		...response?.data,
			// 		manageRedirection: true,
			// 	})
			// );
			yield (window.location = '/pwa' + routes.couponRedemptionOtherWay);
		} else yield put(couponActions.invalidateCouponsSuccess(response?.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			couponActions.invalidateCouponsFailure
		);
	}
}

function* mobileCouponRequest(action) {
	try {
		let response = yield sagaCallService(
			() => services.getCouponListBaseOnMobile(action.payload),
			action
		);
		yield put(couponActions.getCouponsSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(e, action, couponActions.getCouponsFailure);
	}
}

const couponSaga = [
	takeEvery(couponTypes.GET_COUPON.REUQEST, getCouponRequest),
	takeLatest(couponTypes.INVALIDATE_COUPON.REUQEST, invalidateCouponRequest),
	takeLatest(couponTypes.GET_COUPON_MOBILE.REUQEST, mobileCouponRequest),
];
export default couponSaga;
